//
// # Starter
//
// Sole export `start` is the entry point.
// It creates a parent DOM element for the schematic canvas,
// and then starts the editor.
//

// Local Imports
import { Editor } from "./editor";
import { type Platform } from "EditorCore/src/platform";

// This `started` bit is the one module-scope thing in the web app,
// which also lets this be re-entrant,
// although we don't think we've ever screwed up and called it more than once.
let started: boolean = false;

export function start(platform: Platform): void {
  if (started) return;
  started = true;

  // Retrieve the backend URL parameters.
  const params = new URLSearchParams(document.location.search);

  // Create the parent `div` element
  const parentDomElement = document.createElement("div");
  parentDomElement.id = Editor.PARENT_DOM_ID; // NOTE: no longer needed; just debug info.
  document.body.appendChild(parentDomElement);

  // Create the Editor, and start it.
  const _ = new Editor(
    platform,
    parentDomElement,
    { events: true },
    {
      kind: "options",
      options: params, // URL parameters all go here to the canvas options, FWIW.
    }
  );
}
